const DateRangeComponent = {
    templateUrl: '/ui/advancedFilter/component/dateFilter/dateRange/dateRange.tpl.html',
    controller: 'dateRangeController',
    bindings: {
        dateValue: '<',
        valueUpdated: '&',
        startDateLabel: '<',
        endDateLabel: '<',
        allowIndependentDates: '<?',
        allowDateClearing: '<?',
        endDateValidationErrorMessage:'<',
        timezoneMode: '<',
        isDisabled:'<'
    }
};

angular.module('umCore')
    .component('uiDateRange', DateRangeComponent);
